import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetNonComplianceDetailsAsync,
  INonComplianceDetails,
} from "../../api/INonCompliance";
import { RootState } from "../store";

export interface NonComplianceState {
  fetchStatus: string;
  nonCompliance?: INonComplianceDetails;
}

const initialState: NonComplianceState = {
  fetchStatus: "Loading...",
  nonCompliance: undefined,
};

export const loadNonComplianceAsync = createAsyncThunk(
  "nonCompliance/load",
  async (nonComplianceId: string) => {
    const response = await GetNonComplianceDetailsAsync(nonComplianceId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const nonComplianceSlice = createSlice({
  name: "nonCompliance",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadNonComplianceAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadNonComplianceAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.nonCompliance = action.payload;
      });
  },
});

export const selectNonCompliance = (state: RootState) => state.nonCompliance;

export default nonComplianceSlice.reducer;
